import React from 'react';
import { Grid } from '@mui/material';
import { Navigate } from 'react-router-dom';
import HelpFAQ from './HelpFAQ';
import ContactForm from './ContactForm';
import { useIsMexicoDisabled } from '../../helpers/featureFlags';

function FAQ() {
  const isMexicoDisabled = useIsMexicoDisabled();
  if (isMexicoDisabled) {
    return <Navigate to="/" replace />;
  }
  return (
    <Grid>
      <HelpFAQ />
      <ContactForm />
    </Grid>
  );
}

export default FAQ;
